import { Controller } from "@hotwired/stimulus"
import RequestHelper from "../helpers/request_helper"

const PAUSE = "Pause Expiration"
const UNPAUSE = "Unpause Expiration"
const PAUSED_EXPIRATION_MESSAGE = "Credit Expiration has been paused"
const UNPAUSED_EXPIRATION_MESSAGE = "Credit Expiration has been unpaused"
const TOGGLE_FAILURE_MESSAGE = "An error occurred when toggling credit expiration"

export default class extends Controller {
  static get values() { return { url: String, enabled: Boolean }; }

  toggle() {
    // JSON content type is load-bearing: the action reads params[:organization], which only exists
    // because ParamsWrapper nests the flat body, and it only does that for JSON.
    const options = RequestHelper.defaultPatchOptions();
    options.headers = Object.assign({}, options.headers, { "Content-Type": "application/json" });
    options.body = JSON.stringify({ credit_expiration_enabled: !this.enabledValue });

    fetch(this.urlValue, options).
      then(response => {
        if (!response.ok) { throw new Error(`Toggle failed (${response.status})`); }
        return response.json();
      }).
      then(({ credit_expiration_enabled }) => {
        this.enabledValue = credit_expiration_enabled;
        this.element.textContent = this.enabledValue ? PAUSE : UNPAUSE;
        window.ltAlert({
          message: this.enabledValue ? UNPAUSED_EXPIRATION_MESSAGE : PAUSED_EXPIRATION_MESSAGE,
          type: "toast-success",
          duration: 2000
        });
      }).
      catch(() => {
        window.ltAlert({
          message: TOGGLE_FAILURE_MESSAGE,
          type: "toast-error"
        });
      });
  }
}
